import location from "../../../assets/images/contctus/location.svg";
import contact from "../../../assets/images/contctus/contact.svg";
import openingHours from "../../../assets/images/contctus/openingHours.svg";

export default [
  {
    icon: location,
    title: "Address ",
    desc1: "514 E HazelWood St Unit D,",
    desc2: "Princeton TX 75407",
  },
  {
    icon: openingHours,
    title: "Opening Hours",
    desc1: "Mon - Fri:",
    desc2: "10:00 AM - 06:00 PM",
  },
  {
    icon: contact,
    title: "Contact Directly",
    desc1: "hradmin@veritekno.com",
    desc2: "Contact:7632679980",
  },
];
